// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Database as RawDatabase } from "lucide-react";
export const Database = /* @__PURE__ */ createIcon(RawDatabase, "Database", 2);
